(function () {
  'use strict';

  document.addEventListener('change', function (event) {
    var sort = event.target.closest('[data-sort-select]');
    if (sort && sort.form) {
      sort.form.submit();
      return;
    }

    var filterField = event.target.closest('[data-collection-filters] input');
    if (filterField) {
      var filterForm = filterField.closest('[data-collection-filters]');
      if (filterForm) filterForm.submit();
    }
  });

  document.addEventListener('click', function (event) {
    var layout = event.target.closest('[data-layout-switch]');
    if (layout) {
      var target = document.getElementById(layout.getAttribute('aria-controls'));
      if (!target) return;
      var listView = layout.dataset.layoutSwitch === 'list';
      target.classList.toggle('is-list', listView);
      document.querySelectorAll('[data-layout-switch][aria-controls="' + target.id + '"]').forEach(function (button) {
        var active = button === layout;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      return;
    }

    var close = event.target.closest('[data-details-close]');
    if (!close) return;
    var details = close.closest('details');
    if (details) {
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary) summary.focus();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.collection-mobile-control[open], .search-mobile-control[open]').forEach(function (details) {
      details.removeAttribute('open');
      var summary = details.querySelector('summary');
      if (summary) summary.focus();
    });
  });
})();
